"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'fresh',
    name: 'Fresh',
    background_color: '#ffffff',
    background_image: null,
    background_image_portrait: null,
    heading_font: 'https://fonts.raydiant.com/Roboto-Light.woff',
    heading_text_color: '#ff571b',
    heading_2_font: 'https://fonts.raydiant.com/Roboto-Bold.woff',
    heading_2_text_color: '#333333',
    body_font: 'https://fonts.raydiant.com/Roboto-Light.woff',
    body_text_color: '#4596b8',
    border_color: '#4596b8',
};
//# sourceMappingURL=fresh.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/fresh.js